<template>
  <PageWrapper :isLoading="isLoading">
    <template #title>
      جزئیات کاربر {{ userDetails ? userDetails.fullName : "" }}
    </template>
    <BRow v-if="userDetails">
      <BCol cols="12" md="6">
        <TextInput
          readonly
          inputId="userFullName"
          inputLabel="نام زبان آموز"
          inputPlaceholder="رضا..."
          v-model="userDetails.fullName"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          readonly
          inputId="userPhoneNumber"
          inputLabel="شماره زبان آموز"
          inputPlaceholder="0912..."
          v-model="userDetails.mobile"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          readonly
          inputId="userEmail"
          inputLabel="ایمیل زبان آموز"
          inputPlaceholder="info@ferman.org"
          v-model="userDetails.email"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6" class="mt-1" v-if="userDetails.whatsAppLink">
        <small> لینک واتس اپ </small>
        <BButton
          variant="transparent"
          target="_blank"
          :href="whatsappDesktopLinkGenerator(userDetails.whatsAppLink)"
          class="d-lg-block d-none"
        >
          <WhatsappIcon></WhatsappIcon>
        </BButton>
        <BButton
          variant="transparent"
          target="_blank"
          :href="whatsappMobileLinkGenerator(userDetails.whatsAppLink)"
          class="d-block d-lg-none"
        >
          <WhatsappIcon></WhatsappIcon>
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["getUserDetails"],
  mounted() {
    this.getUserDetails();
  },
  data() {
    return {
      isLoading: false,
      userDetails: null,
    };
  },
  methods: {
    whatsappDesktopLinkGenerator(mobile) {
      return `https://web.whatsapp.com/send?phone=${mobile ? mobile : ""}`;
    },
    whatsappMobileLinkGenerator(mobile) {
      return `https://api.whatsapp.com/send?phone=${mobile ? mobile : ""}`;
    },
    async getUserDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getLiteUserById = new GetLiteUserById(_this);
        getLiteUserById.setRequestParam({
          id: _this.$route.params.id,
        });
        await getLiteUserById.fetch((res) => {
          _this.userDetails = res;
          _this.$emit("getUserDetails", res);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    WhatsappIcon,
    TextInput,
    BRow,
    BCol,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import WhatsappIcon from "@/views/components/Icons/WhatsappIcon.vue";
import { GetLiteUserById } from "@/libs/Api/Users";
import { BRow, BCol, BButton } from "bootstrap-vue";
</script>
